import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1731939650__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Idee", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1731939650__cls-1{fill:none}.i-1731939650__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M132 36c-11.03 0-20 9.04-20 20.15 0 7.64 4.23 14.54 11.03 17.99 1.34.68 2.19 2.06 2.19 3.57v2.3h13.55v-2.3c0-1.51.85-2.89 2.19-3.57 6.81-3.45 11.03-10.34 11.03-17.99 0-11.11-8.97-20.15-20-20.15Zm0 14.04c-3.46 0-6.27 2.84-6.27 6.34h-8c0-7.91 6.4-14.34 14.27-14.34z",
      class: "i-1731939650__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "60",
      cy: "92",
      r: "16",
      class: "i-1731939650__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M60 68c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24m0 40c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16M81.69 124H38.33c-8.63 0-16.27 5.73-18.59 13.93L8.16 178.89l7.7 2.18 11.59-40.96c1.35-4.77 5.83-8.11 10.89-8.11H81.7c5.07 0 9.55 3.34 10.89 8.11l11.57 40.97 7.7-2.17-11.56-40.97C97.99 129.73 90.34 124 81.71 124ZM117.73 56.38h8c0-3.49 2.81-6.34 6.27-6.34v-8c-7.87 0-14.27 6.43-14.27 14.34",
      class: "i-1731939650__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M132 28c-15.44 0-28 12.63-28 28.15 0 9.83 5.01 18.77 13.22 23.89V84c0 2.21 1.79 4 4 4h21.55c2.21 0 4-1.79 4-4v-3.96c8.22-5.12 13.22-14.06 13.22-23.89 0-15.52-12.56-28.15-28-28.15Zm8.97 46.14a4 4 0 0 0-2.19 3.57v2.3h-13.55v-2.3c0-1.51-.85-2.89-2.19-3.57-6.81-3.45-11.03-10.34-11.03-17.99 0-11.11 8.97-20.15 20-20.15s20 9.04 20 20.15c0 7.64-4.23 14.54-11.03 17.99ZM119 92h26v8h-26z",
      class: "i-1731939650__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "personIdea"}) } }